import { lazyLoad } from 'utils/loadable';

export const NotificationListPage = lazyLoad(
  () => import('./index'),
  module => module.NotificationListPage,
);
